var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolutionsPermits(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 66.14 61.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ff6e14;}.cls-3{fill:#d0dbfb;}.cls-4{fill:#948dbd;}.cls-5{fill:#544993;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 10.76,
    y: 7.69,
    width: 29.85,
    height: 38.04
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 17.62,
    y: 13.78,
    width: 29.85,
    height: 38.04
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 23.3,
    y: 20.25,
    width: 19.28,
    height: 3.96
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 23.3,
    y: 27.34,
    width: 19.28,
    height: 3.96
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 23.3,
    y: 34.42,
    width: 19.28,
    height: 3.96
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 23.3,
    y: 41.51,
    width: 8.51,
    height: 3.96
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 44.08,
    cy: 41.84,
    r: 12.32
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "42.23 47.26 37.54 42.57 39.17 40.94 42.23 44 48.99 37.24 50.62 38.87 42.23 47.26"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionsPermits);
export default __webpack_public_path__ + "static/media/Solutions_Permits.55d1213d7ebba23534f3f4de1b400b70.svg";
export { ForwardRef as ReactComponent };